import { cloneElement, useState } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import Box from '@mui/material/Box';

export type ClipboardShareProps = {
  url: string;
  children: React.ReactElement;
} & Omit<TooltipProps, 'title'>;

export function ClipboardShare({
  url,
  children,
  sx,
  ...props
}: ClipboardShareProps) {
  const [isOpen, setIsOpen] = useState(false);
  const hide = () => {
    setIsOpen(false);
  };
  const show = () => {
    navigator.clipboard.writeText(url);
    setIsOpen(true);
    setTimeout(hide, 2000);
  };

  return (
    <ClickAwayListener onClickAway={hide}>
      <Tooltip
        open={isOpen}
        onClose={hide}
        disableFocusListener
        disableHoverListener
        title="Copied to clipboard!"
        arrow
        placement="bottom"
        sx={{ ...sx, '&:hover': { cursor: 'pointer' } }}
        {...props}
      >
        <Box>{cloneElement(children, { onClick: show })}</Box>
      </Tooltip>
    </ClickAwayListener>
  );
}
